import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3.01 1L3 17l9 6 8.99-6L21 1H3.01zM10 16l-5-5 1.41-1.42L10 13.17l7.59-7.59L19 7l-9 9z"
}), 'BeenhereSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BeenhereSharp.js
// module id = 2336
// module chunks = 2